import SPAHeadUpdater from "@resources/SPAHeadUpdater/SPAHeadUpdater";

class FetchModalBasedOnAnchorClass {
	constructor() {
		document.addEventListener("click", this.handleOpenClick.bind(this));
		document.addEventListener("click", this.handleClose.bind(this));
		window.addEventListener('DOMContentLoaded', () => {
			window.addEventListener("popstate", this.handlePopState.bind(this));
		})
		this.actualPage = false;
		this.registeredFetchs = [];
		this.openModals = [];
	}

	registerFetch(param, name, modalId, modalAuxiliarClasses, responseSelector, closeButtonSelector, beforeOpenEvent = false) {
		let isRegistered = this.registeredFetchs.length && this.registeredFetchs.filter(registered => registered.name === name).length
		if (isRegistered) {
			console.warn(`Fetch type ${name} already registered:`, isRegistered[0])
			return;
		}
		this.registeredFetchs.push({
			param: param,
			name: name,
			modalId: modalId,
			responseSelector: responseSelector,
			closeButtonSelector: closeButtonSelector,
			modalClassName: modalAuxiliarClasses,
			beforeOpenEvent: beforeOpenEvent,
		})
	}

	getFetchTarget(urlString) {
		if (!this.registeredFetchs.length) {
			return false;
		}
		const url = new URL(urlString);
		let fetchTarget = this.registeredFetchs.filter(registered => url.searchParams.get(registered.param) == registered.name);
		return fetchTarget.length && fetchTarget[0];
	}


	async handleOpenClick(e) {
		const target = e.target.closest("a");
		if (!target || !this.registeredFetchs.length) return;

		let fetchTarget = this.getFetchTarget(target.href);
		console.log(this.registeredFetchs);
		if (!fetchTarget) return;

		e.preventDefault();
		this.handleOpen(target.href, fetchTarget);
	}

	async handleOpen(url, fetchTarget, pushState = true) {
		try {
			const response = await fetch(url);
			const text = await response.text();
			const parser = new DOMParser();
			const page = parser.parseFromString(text, "text/html");
			const content = page.querySelector(fetchTarget.responseSelector);

			this.updateHead(page, true);
			this.openModal(content.innerHTML, fetchTarget);
			pushState && history.pushState({ modal: true }, "", url);

		} catch (error) {
			console.error("Error fetching content:", error);
		}
	}

	handleClose(e) {
		const target = this.registeredFetchs.filter(registered => e.target.closest(registered.closeButtonSelector))
		if (!target.length) return;
		e.preventDefault();
		this.closeModal()
		history.back();
	}

	handlePopState(e) {
		const fetchTarget = this.getFetchTarget(window.location.href)
		if (fetchTarget) {
			this.handleOpen(window.location.href, fetchTarget, false);
		} else {
			this.closeModal();
		}
	}

	openModal(htmlContent, fetchTarget) {
		let modal = document.createElement("div");

		if (this.openModals.filter(m => m === modal).length) {
			return;
		}

		let addClassNames = fetchTarget.modalClassName.split(' ');

		document.documentElement.style.overflow = 'hidden';
		modal.id = fetchTarget.modalId;
		addClassNames.map(className => modal.classList.add(className));
		document.body.appendChild(modal);
		modal.innerHTML = htmlContent;

		if (typeof fetchTarget.beforeOpenEvent === 'function') {
			const eParams = {
				modal: modal,
				htmlContent: htmlContent,
				fetchTarget: fetchTarget,
			}
			htmlContent = fetchTarget.beforeOpenEvent(eParams)?.htmlContent || htmlContent;
		}

		this.openModals.push(modal);

		modal.style.opacity = 0;
		setTimeout(() => {
			modal.style.opacity = null;
		}, 10);
	}

	closeModal(fetchTarget) {
		let modal = this.openModals.length && this.openModals[this.openModals.length - 1]
		if (modal) {
			document.documentElement.style.overflow = null;
			modal.remove(fetchTarget);
			delete this.openModals[this.openModal.length - 1];
		}
		this.updateHead(false)
	}

	async updateHead(parsedPage) {
		this.actualPage = parsedPage ? document.cloneNode(true) : this.actualPage;
		let SPA = new SPAHeadUpdater(parsedPage ? parsedPage : this.actualPage, false);
		await SPA.init();
		return true;
	}


}

const FetchModalBasedOnAnchor = new FetchModalBasedOnAnchorClass();
export default FetchModalBasedOnAnchor;
